import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AuthAPI from "services/AuthAPI";
import { storeToken } from "../../utils/storage";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updatePermissions, updateRoleName, updateUserLogin } from "../../redux/slices/userSlice";
import { Loader } from "components";
import { IntroScreen, IntroDisplayTime } from "./IntroScreen";
import { inactiveSessionKey } from "utils/autoLogout";

export default function AutoLogin() {
  const [searchParams] = useSearchParams();
  const params = searchParams.get("code");
  const dispatch = useDispatch();
  const [showIntro, setShowIntro] = useState(false);
  const isIntroImageLoadCallback = useRef(null)
  const [loginResponse, setLoginResponse] = useState({})
  const [isIntroImgLoaded, setIsIntroImgLoaded] = useState(null);

  const apiInstance = new AuthAPI();
  // here is testing

  useEffect(() => {
    handleAutoLogin();
  }, []);

  useEffect(() => {
      isIntroImageLoadCallback.current = ({isIntroImgLoaded}) => {
        setIsIntroImgLoaded(isIntroImgLoaded)
      }
  
    }, [isIntroImgLoaded])

  const handleAutoLogin = async () => {
    const res = await apiInstance.autoLoginAPI(params);
    window.localStorage.removeItem(inactiveSessionKey);
    setLoginResponse(res);
    if (res?.statusCode === 200) {
      storeToken(res.data.token);
      toast.success(res.message);
      dispatch(updatePermissions(res.data.permissions));
      dispatch(updateRoleName(res.data.roleName));
    } else {
      toast.error(res.message);
    }
  };

  useEffect(() => {
      if(isIntroImgLoaded && loginResponse.statusCode === 200) {
          setShowIntro(true)
          setTimeout(() => {
            dispatch(updateUserLogin(true));
          }, IntroDisplayTime);
        }
  
    }, [isIntroImgLoaded, loginResponse, dispatch])

    console.log({isIntroImgLoaded, statusCode: loginResponse?.statusCode})

  return <>{!showIntro ? <Loader /> : null}
    <IntroScreen
      showIntro={showIntro}
      updateCallbackRef={isIntroImageLoadCallback}
    /></>
}
